import { render, staticRenderFns } from "./booker.vue?vue&type=template&id=5118d2be&"
import script from "./booker.vue?vue&type=script&lang=js&"
export * from "./booker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports